import script from "./TableOfContents.vue?vue&type=script&setup=true&lang=js"
export * from "./TableOfContents.vue?vue&type=script&setup=true&lang=js"

import "./TableOfContents.vue?vue&type=style&index=0&id=e5fbc596&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5fbc596"]])

export default __exports__